import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/04-pages/Login'
import Logout from '@/components/04-pages/Logout'
import Signup from '@/components/04-pages/Signup'
import Resetpassword from '@/components/04-pages/Resetpassword'

import Home from '@/components/04-pages/Home'
import NewCover from '@/components/04-pages/NewCover'
import Books from '@/components/04-pages/Books'
import Book from '@/components/04-pages/Book'
import Cover from '@/components/04-pages/Cover'
import Chapters from '@/components/04-pages/Chapters'
import Bodies from '@/components/04-pages/Bodies'
import Bodie from '@/components/04-pages/Bodie'
import Account from '@/components/04-pages/Account'

Vue.use(Router)

const route = {
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/resetpassword',
      name: 'Resetpassword',
      component: Resetpassword
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      children: [
        {
          path: 'books',
          name: 'Books',
          component: Books
        },
        {
          path: 'books/new',
          name: 'NewCover',
          component: NewCover
        },
        {
          path: 'books/:id',
          name: 'Book',
          component: Book,
          children: [
            {
              path: 'cover',
              name: 'Cover',
              component: Cover
            },
            {
              path: 'chapters',
              name: 'Chapters',
              component: Chapters
            },
            {
              path: 'bodies',
              name: 'Bodies',
              component: Bodies
            },
            {
              path: 'bodies/:body_id',
              name: 'Bodie',
              component: Bodie
            }
          ]
        },
        {
          path: 'account',
          name: 'Account',
          component: Account
        }
      ]
    }
  ]
}

export default new Router(route)



// WEBPACK FOOTER //
// ./src/router/index.js